import { Header, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { addMonths, isBefore, parse, startOfToday } from 'date-fns';
import TableBookings from '../../../../../components/tables/tableBookings';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking } from '../../../../../resources/types';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const MembersBookingMyBookingsPage = () => {
    const [weCanBook, setWebCanBook] = useState(false);




    //const { finish, setFinish } = useGlobalState(false);
    const [bookings, setBookings] = useState<ItemBooking[]>([]);
    const [booking, setBooking] = useState<ItemBooking>();

    const { idUser, menu, parameters } = useGlobalState();
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const [loading, setLoading] = useState<boolean>(true);



    const today = startOfToday();
    useEffect(() => {
        setWebCanBook(false)
        if (parameters.date) {

            const targetDate = parse(parameters.date, 'dd-MM-yyyy', new Date());
            if (!isBefore(targetDate, today)) {
                setWebCanBook(true)
            }

        }
        handleRefresh()
    }, [parameters]);





    const handleDeleteBooking = async (idBooking: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/bookings/delete',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idBooking: idBooking,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0) {
                    handleRefresh()
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false);
        }
    }


    const handleRefresh = async () => {
        if (parameters && parameters.period !== "") {
            try {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        month: parameters.period.split("-")[1],
                        year: parameters.period.split("-")[0],
                        idUserOrInstructor: idUser,
                        orderBy: "dateStart",
                        order: "desc",
                        orderBy2: "dateEnd",
                        order2: "desc"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings)
                }
                //storeAdmin(data);
                // Create a new list with updated 'accesos' field before setting it to state

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };


    useEffect(() => {
        handleRefresh();
    }, []);



    return (
        <CustomAppLayout
            toolsHide={true}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">


                    <Header
                        description="Reservas realizadas por usted o como instructor asignado"

                        actions={


                            <Favorites />
                        }>Mis Reservas
                    </Header>

                    <>
                        <TableBookings
                            filter={
                                <div style={{ width: 130 }}>
                                    <MPModal
                                        width={120}
                                        today prevMonth nextMonth
                                        end={addMonths(new Date(), 1)}
                                        date={`${parameters.period}`}
                                        onConfirm={(date) => {
                                            setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                        }}
                                    />
                                </div>
                            }
                            canDelete={true} click={true} headers={false} range={false}
                            bookings={bookings} visible={true}
                            onBookingClick={(book) => {
                                //console.log(book)
                                setBooking((prev) =>
                                    prev ? { ...prev, obsBooking: "" } : prev
                                );;
                            }}
                            onBookingDelete={(booking) => {
                                handleDeleteBooking(booking.idBooking)
                            }}
                        />

                    </>
                </SpaceBetween >
            }
        />

    );
};